module.exports = __webpack_public_path__ + "static/media/screen1.68e7aa02.png";